import React, { useState } from 'react';
import { Flag, getFlagIcon, FlagStatus } from '../Label/useValidationFlags';

const useIcon = (
  flag: Flag, 
  x: number, 
  y: number, 
  size: number,
  seekToFrame: (frameId: number) => void,
  hide: boolean = false,
) => { 
  const [hover, setHover] = useState<boolean>(false);
  const color: string = flag.status === FlagStatus.Unresolved ? "#900" : "#090";

  const mouseEnter = () => {
    setHover(true);
  };
  const mouseLeave = () => {
    setHover(false);
  };
  const onClick = () => {
    seekToFrame(flag.start);
  };

  return hide 
  ? <React.Fragment key={flag.id}>
    </React.Fragment> 
  : <React.Fragment key={flag.id}>
    {/* Icon Graphic */}
    <svg 
      x={x-(size*0.5)} 
      y={y-(size*0.5)} 
      width={size} 
      height={size} 
      viewBox="0 0 100 100"
    >
      {/* Background */}
      <rect 
        width={100}
        height={100}
        fill={color}
      />
      <rect 
        x={10}
        y={10}
        width={80}
        height={80}
        fill={"#fff"}
      />
      {/* Icon Graphic */}
      <svg
        x={15}
        y={15}
        width={70}
        height={70}
      >
        {getFlagIcon(flag)}
      </svg>
    </svg>

    {/* Hover Display */}
    {hover && <text
      x={x+size*0.5} 
      y={y-(size*0.7)}
      fontSize={size*0.7} 
      dominantBaseline="middle" 
      textAnchor="middle"
      fontWeight="bold"
    >
      {flag.id}
    </text>}
    {/* Hitbox */}
    <rect 
      x={x-(size*0.5)} 
      y={y-(size*0.5)} 
      width={size} 
      height={size}
      opacity={0}
      cursor="pointer"
      onMouseMove={mouseEnter}
      onMouseLeave={mouseLeave}
      onClick={onClick}
    />
  </React.Fragment>;
};

type Props = {
  xStart: number;
  xEnd: number;
  swXStart: number;
  swXEnd: number;
  timelineY: number;
  swY: number; 
  flag: Flag;
  seekToFrame: (frameId: number) => void;
  showInSw: boolean;
};

const TimelineFlag = (props: Props) => {
  const { 
    xStart,
    xEnd,
    swXStart,
    swXEnd,
    timelineY,
    swY,
    flag,
    seekToFrame,
    showInSw,
  } = props;

  const swIcon = useIcon(flag, swXStart, swY-36, 24, seekToFrame);
  const timelineIcon = useIcon(flag, xStart, timelineY-40, 20, seekToFrame);
  const color: string = flag.status === FlagStatus.Unresolved ? "#900" : "#090";

  return (
    <React.Fragment key={flag.id}>
      {/* Global timeline */}
      <line x1={xStart} x2={xEnd} y1={timelineY - 12} y2={timelineY - 12} stroke={color} strokeOpacity={0.5} strokeWidth={12} strokeDashoffset="5 5" />
      <line x1={xStart} x2={xStart} y1={timelineY} y2={timelineY - 28} stroke={color} strokeWidth={5} />
      <line x1={xEnd} x2={xEnd} y1={timelineY} y2={timelineY - 28} stroke={color} strokeWidth={5} />
      {timelineIcon}

      {/* Sliding Window */}
      {showInSw && <>
        <line x1={swXStart} x2={swXEnd} y1={swY - 12} y2={swY - 12} stroke={color} strokeOpacity={0.5} strokeWidth={12} strokeDashoffset="5 5" />
        <line x1={swXStart} x2={swXStart} y1={swY} y2={swY - 24} stroke={color} strokeWidth={5} />
        <line x1={swXEnd} x2={swXEnd} y1={swY} y2={swY - 24} stroke={color} strokeWidth={5} />
        {swIcon}
      </>}
    </React.Fragment>
  );
};

export default TimelineFlag;